import { render, staticRenderFns } from "./SupplierOrderDetail.vue?vue&type=template&id=4ccb121c&scoped=true&"
import script from "./SupplierOrderDetail.vue?vue&type=script&lang=js&"
export * from "./SupplierOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOrderDetail.vue?vue&type=style&index=0&id=4ccb121c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccb121c",
  null
  
)

export default component.exports